import styled from 'styled-components';

export const STyledTextEditor = styled.div`
  flex-grow: 1;
  position: relative;
  padding: 20px 20px 0 10px;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: -13px;
    bottom: 0;
    width: 1px;
    background: #e6e7ec;
  }

  .editor-head,
  .subject-holder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 25px;
  }
  .variables-select {
    position: relative;
    .react-select__multi-value {
      display: none;
    }

    .variables-select-placeholder {
      position: absolute;
      top: 50%;
      left: 20px;
      transform: translateY(-50%);
      z-index: 1;
      font-size: 14px;
      line-height: 18px;
      cursor: pointer;
      pointer-events: auto;
      color: #999;
      user-select: none;
    }

    .react-select__input-container {
      opacity: 0;
    }
  }

  .editor-head {
    padding: 0 0 16px;
    border-bottom: 1px solid #efefef;

    label {
      display: block;
      color: var(--text-color-50);
      font-weight: 700;
    }

    input {
      flex-grow: 1;
      background: transparent;
      border: none;
      outline: none;
      color: var(--light-gray);
    }

    .variables-select {
      width: 250px;
      z-index: 3;

      .react-select__control {
        height: 40px;
      }
    }

    .save-btn {
      width: 100%;
      max-width: 520px;
      display: flex;
      align-items: center;
      gap: 10px;

      button {
        font-weight: 600;
        background: var(--blue);

        &.btn-preview {
          color: var(--blue);
          background: rgba(49, 123, 255, 0.1);
        }
      }
    }
  }

  .editor-holder {
    height: calc(100vh - 330px);
  }

  .tox-edit-area__iframe {
    body {
      margin: 0 !important;
    }
  }

  .tox-tinymce {
    border: none;
    height: 100% !important;
  }

  .tox-edit-area__iframe,
  .tox-editor-header,
  .tox-toolbar-overlord,
  .tox-toolbar__primary {
    background-color: transparent !important;
    box-shadow: none !important;
  }

  .tox-edit-area {
    &:before {
      display: none !important;
    }
  }
`;
